import "./App.css";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "./components/Auth/Login/Login";
import DefaultLayout from "./components/Layout/DefaultLayout/DefaultLayout";
import Explore from "./components/Explore/Explore";
// import CalculateRefund from "./components/RefundModal/CalculateRefund/CalculateRefund";
import axios from "axios";
import { GlobalState } from "./context/GlobalContext";
import BusinessPlanning from "./components/BusinessPlanning/BusinessPlanning";
import BusinessPlanningProvider from "./context/BusinessPlanningContext";
import BusinessPlanV2Provider from "./context/BusinessPlanV2Context";
import BusinessPlanV2 from "./components/BusinessPlanV2/BusinessPlanV2";
import SelectedPlanPage from "./components/BusinessPlanV2/SelectedPlanView/SelectedPlanPage";
import StoreBp from "./components/BusinessPlanV2/StoreBp/StoreBp";
import SupplierForm from "./components/SupplierPage/SupplierForm/SupplierForm";
import DefaultOpenLayout from "./components/Layout/DefaultOpenLayout/DefaultOpenLayout";
import AuthProvider from "./context/AuthContext";
import SupplierDashboard from "./components/SupplierPage/SupplierDashbord/SupplierDashboard";
import OwnProductionCostingDashboard from "./components/OwnProductionCosting/OwnProductionCostingDashbord/OwnProductionCostingDashboard";
// import CategoryLevelBp from "./components/BusinessPlanning/CategoryLevelBp/CategoryLevelBp";
import UcVsGynesis from "./components/UcVsGynesis/UcVsGynesis";
import Myntra_reco from "./components/MyntraReco";
import Store from "./components/BusinessPlanning/Store/Store";
import SubCategoryLevelBp from "./components/BusinessPlanning/Store/SubCategoryLevelBp/StoreLevelBp/SubCategoryLevelBp";
import EBOPayments from "components/EBOPayments/EBOPayments";
import Users from "components/Users/Users";
import Dashboard from "components/Layout/Dashboard/Dashboard";
import SupplierUser from "components/SupplierPage/SupplierUser/SupplierUser";
import DashboardSupplierUser from "components/SupplierPage/SupplierDashbord/SupplierUser/SupplierUser";
import {
	generateSupplierRoutesFromDrawer,
	supplierDrawerElements,
	supplierExternalNavBasePath,
	supplierExternalRootPath,
	supplierInternalNavBasePath,
	supplierInternalRootPath,
} from "data/supplierPageData";

import { webDataDrawerElements, webDataParamName } from "data/radhamaniPageData";
import DashboardRWebData from "components/RadhamaniWebData/RadhamaniWebData";
import ChangePassword from "components/Auth/ChangePassword/ChangePassword";
import { rootProtectedPath, services } from "data/authData";
import { itemMasterDrawerElements, itemMasterTabParamName } from "data/itemMasterData";
import ItemMasterDashboard from "components/ItemMaster/ItemMaster";

import DataHub from "components/DataHub/DataHub";
import { DataHubDrawerElements, DataHubTabParamName } from "data/DataHubData";
import { myntra_reco_drawer, myntraRecoUrlParamName } from "data/myntraRecoData";
import LoadingScreen from "components/commonComponents/LoadingScreen";
import DataHubStoreView from "components/DataHub/DataHubStore/DataHubStoreView";
import EboStoresHome from "components/EboStoreV4/EboStoreV4";
import EboStoresList from "components/EboStoreV4/EboStoresList/EboStoresList";
import EboStoreProvider from "context/EboStoreContext";
import { eboAllStoresPage, eboSelectedStorePage } from "components/EboStoreV4/data";
import SelectedStoreDashboard from "components/EboStoreV4/SelectedStoreDashboard/SelectedStoreDashboard";
import { eboStoreDrawerElements } from "components/EboStoreV4/SelectedStoreDashboard/data";
import MboLfsHome from "components/MboLfsV2/MboLfsV2";
import { mbolfsAllStoresPage, mbolfsSelectedStorePage } from "components/MboLfsV2/data";
import MboLfsStoreList from "components/MboLfsV2/MboLfsStoreList/MboLfsStoreList";
import { mboStoreDrawerElements } from "components/MboLfsV2/MboSelectedStoreDashboard/data";
import MboSelectedStoreDashboard from "components/MboLfsV2/MboSelectedStoreDashboard/MboSelectedStoreDashboard.js";
import DataHubWarehouseView from "components/DataHub/DataHubWH/DataHubWHView";
import ForgotPasswordReset from "components/Auth/ForgotPasswordReset/ForgotPasswordReset";
import { replenishmentDrawerElements, replenishmentParamName } from "components/ReplenishmentDashboard/data";
import ReplenishmentDashboard from "components/ReplenishmentDashboard/ReplenishmentDashboard";
import MboPaymentWorking from "components/MboPaymentWorking/MboPaymentWorking";
import { mboPaymentDashboardServices } from "components/MboPaymentWorking/data";
import MboSalePaymentWorking from "components/MboSalePaymentWorking/MboSalePaymentWorking";
import { mboSalePaymentDashboardServices } from "components/MboSalePaymentWorking/data";
import MboSalePaymentWorkingExplore from "components/MboSalePaymentWorking/MboSalePaymentWorkingExplore";
import LfsSalePaymentWorking from "components/LfsSalePaymentWorking/LfsSalePaymentWorking";
import { lfsSalePaymentDashboardServices } from "components/LfsSalePaymentWorking/data";
import LfsSalePaymentWorkingExplore from "components/LfsSalePaymentWorking/LfsSalePaymentWorkingExplore";
import DashboardWithMiniCollapsableDrawer from "components/Layout/DashboardWithMiniCollapsableDrawer/DashboardWithMiniCollapsableDrawer";
import MboPaymentProvider from "context/MboPaymentContext";
import MboPaymentWorkingExplore from "components/MboPaymentWorking/MboPaymentWorkingExplore/MboPaymentWorkingExplore";
import ReplenishmentProvider from "context/ReplenishmentContext.js";
import StoreBudgetTracker from "components/StoreBudgetTracker/StoreBudgetTracker";
// import FormDialog from "components/EboStoreV3/Form/Form";

import DesignerWorkspace from "components/DesignerWorkspace/DesignerWorkspace";
import CADWorkspace from "components/CADWorkspace/CADWorkspace";
import FinanceWorkspace from "components/FinanceWorkspace/FinanceWorkspace";
import { generateReportsRoutesFromServiceTree, reportsDashboardSideNavList } from "components/Reports/data";
import ReportsProvider from "context/ReportsContext";
import Reports from "components/Reports/Reports";
import { generateReplenishmentRoutesFromServiceTree } from "data/replenishmentData";
import HRWorkspace from "components/HRWorkspace/HRWorkspace";
import MboSaleWorkspace from "components/MboSaleWorkspace/MboSaleWorkspace";
import OpsReportWorkspace from "components/OpsReportWorkspace/OpsReportWorkspace";
import { adyogiReportsDashboardSideNavList, generateAdyogiReportsRoutesFromServiceTree } from "components/AdyogiExternalReports/data";
import { generateCustomQueriesRoutesFromServiceTree } from "data/customQueriesData";
import { customQuereiesDrawerElements, planningSaleQueryPath } from "components/CustomQueriesDashboard/data";
import CustomQueriesProvider from "context/CustomQueriesContext";
import { audienceDrawerElements, audienceFacebookPagePath } from "components/AudienceDashboard/data";
import AudienceDashboardProvider from "context/AudienceDashboardContext";
import { generateAudienceRoutesFromServiceTree } from "data/AudienceDashboardData";
import { generateGujratSaleRoutesFromServiceTree, gujratSaleExternalDashboardSideNavList } from "components/GujratSaleExternal/data";
import AopTracker from "components/AopTracker/AopTracker";
import Exclusion from "components/Exclusion/Exclusion.js";
import Giga from "components/Giga/Giga";
import GigaRunPage from "components/Giga/GigaRunPage";
import { useEffect } from "react";
import ReturnModule from "components/ReturnModule/ReturnModule";
import ReturnModuleDashboard from "components/ReturnModule/components/Dashboard";
import AxisRouteGuard from "components/WHAllocation/AxisRouteGuard";
import ShippingProviderRecoProvider from "context/shippingProviderRecoContext";
import { shippingPartnerDrawerElements } from "components/ShippingPartnerReco/data";
import { generateShippingPartnerRecoRoutesFromServiceTree } from "data/shippingPartnerRecoData";
import PosRecoProvider from "context/PosRecoContext";
import { generatePosRoutesFromServiceTree, posDashboardSideNavList } from "components/POSReco/data";
import FabricSourcingWorkspace from "components/FabricSourcingWorkspace/FabricSourcingWorkspace";
import CrmWorkspace from "components/CrmWorkspace/CrmWorkspace";
import StoreRecommendationProvider from "context/StoreRecommendationContext";
import {
	generateStoreRecommendationRoutesFromServiceTree,
	storeRecommendationDashboardSideNavList,
} from "components/StoreRecommendation/data";
import FinancePayableWorkspace from "components/FinancePayableWorkspace/FinancePayableWorkspace";
import StudioWorkspace from "components/StudioWorkspace/StudioWorkspace";
import { store_budget_tracker_data, storeBudgetDashboardServices } from "data/storeBudgetData";
import StoreBudgetExplore from "components/StoreBudgetTracker/StoreBudgetExplore/StoreBudgetExplore";
import StoreBudgetProvider from "context/StoreBudgetTrackerContext";
import ItWorkspace from "components/ItWorkspace/ItWorkspace";
import VmWorkspace from "components/VmWorkspace/VmWorkspace";
import DiscountActionPage from "components/MboPaymentWorking/DiscountMaster/DiscountActionPage/DiscountActionPage";
import PrivacyPolicy from "components/PrivacyPolicy/PrivacyPolicy";
import TermsOfService from "components/TermsOfService/TermsOfService";
import { eboPaymentDashboardServices } from "components/EboPaymentWorking/data";
import EboPaymentWorkingExplore from "components/EboPaymentWorking/EboPaymentWorkingExplore";
import EboPaymentWorking from "components/EboPaymentWorking/EboPaymentWorking";
import EboPaymentProvider from "context/EboPaymentContext";
import EboStoreExpensesExplore from "components/EboStoreExpenses/EboStoreExpensesExplore";
import EboStoreExpenses from "components/EboStoreExpenses/EboStoreExpenses";
import EboStoreExpensesProvider from "context/EboStoreExpenses";
import { eboStoreExpensesServices } from "components/EboStoreExpenses/data";
import PragmaAutoMail from "components/PragmaAutoMail/PragmaAutoMail";
import { refundTrackerServices } from "components/RefundTracker/data";
import RefundTrackerPage from "components/RefundTracker/RefundTracker";
import RefundTrackerExplore from "components/RefundTracker/RefundTrackerExplore";
import RefundTrackerProvider from "context/RefundTracker";

// SORA lives at its own subdomain now (standalone app, sign-in via hq). Any visit to the old
// in-app path forwards there — replace() keeps the dead page out of browser history.
const SoraMoved = () => {
	useEffect(() => {
		window.location.replace("https://sora.thehouseofrare.com");
	}, []);
	return null;
};

function App() {
	const { snackBar, snackBarOpen, setSnackBarOpen } = GlobalState();
	axios.defaults.baseURL = process.env.REACT_APP_API_URL;
	axios.defaults.headers["Content-Type"] = `application/json`;
	axios.interceptors.response.use(
		(response) => {
			// console.log("✅ Response:", response.status, response.config.url);
			return response;
		},
		(error) => {
			if (error.response?.status === 401) {
				console.warn("🔒 Unauthorized! Redirecting to login...");
				localStorage.removeItem("user_token");
				localStorage.removeItem("py_token");
				//   window.location.href = "/login";
				window.location.reload(true);
			}
			return Promise.reject(error);
		},
	);

	return (
		<Box className="App">
			{/* for alert messages */}
			<LoadingScreen />
			<Snackbar
				open={snackBarOpen}
				autoHideDuration={4000}
				onClose={() => setSnackBarOpen(false)}
				anchorOrigin={snackBar.anchorOrigin}>
				<Alert onClose={() => setSnackBarOpen(false)} severity={snackBar.severity} sx={{ width: "100%" }}>
					{snackBar.message}
				</Alert>
			</Snackbar>

			<Routes>
				<Route path="/" element={<Login />} />
				{/* only explore has authentication */}
				<Route
					path={rootProtectedPath}
					element={
						<AuthProvider>
							<DefaultLayout />
						</AuthProvider>
					}>
					<Route index element={<Explore />} />
					<Route path={services.pragma_auto_mail.path} element={<PragmaAutoMail />} />
					{/* <Route path="calc_refund_RM" element={<CalculateRefund />} /> */}
					<Route path={services.supplier_dashboard.path}>
						<Route index element={<SupplierDashboard />} />
						<Route path="supplier_info">
							<Route index element={<Navigate to="company_info" replace />} />
							{generateSupplierRoutesFromDrawer(supplierDrawerElements, {
								rootPath: supplierInternalRootPath,
								navBasePath: supplierInternalNavBasePath,
								element: <DashboardSupplierUser />,
								// DefaultLayout already clears the top AppBar
								navSpace: 0,
							})}
						</Route>
					</Route>
					{/* <Route path={services.ebo_stores.path} element={<StoreProvider />} /> */}
					<Route path={services.ebo_stores.path} element={<EboStoreProvider />}>
						<Route index element={<EboStoresHome />} />
						<Route path={eboAllStoresPage} element={<EboStoresList />} />
						{/* <Route path={eboSelectedStorePage} element={<SelectedStore />} /> */}
						<Route
							path={eboSelectedStorePage}
							element={
								<Dashboard drawerList={eboStoreDrawerElements} searchParamName={webDataParamName} navSpace={0} />
							}>
							<Route index element={<SelectedStoreDashboard />} />
						</Route>
					</Route>

					<Route path={services.mbo_stores.path}>
						<Route index element={<MboLfsHome />} />
						<Route path={mbolfsAllStoresPage} element={<MboLfsStoreList />} />
						<Route
							path={mbolfsSelectedStorePage}
							element={
								<Dashboard drawerList={mboStoreDrawerElements} searchParamName={webDataParamName} navSpace={0} />
							}>
							<Route index element={<MboSelectedStoreDashboard />} />
						</Route>
					</Route>

					<Route path={services.production_costing.path} element={<OwnProductionCostingDashboard />} />

					<Route path={services.uc_vs_ginesys.path} element={<UcVsGynesis />} />
					<Route path={services.it_workspace.path} element={<ItWorkspace />} />
					<Route path={services.vm_workspace.path} element={<VmWorkspace />} />
					<Route path={services.exclusions.path} element={<Exclusion />} />
					<Route path={services.giga.path}>
						<Route index element={<Giga />} />
						<Route path="run/:id" element={<GigaRunPage />} />
					</Route>
					<Route path={services.aop.path} element={<AopTracker />} />

					<Route element={<ReportsProvider />} path="reports">
						<Route index element={<Navigate to="SALE/thor_live_sale" replace />} />
						{Object.keys(reportsDashboardSideNavList).map((key) =>
							generateReportsRoutesFromServiceTree(reportsDashboardSideNavList[key], "reports"),
						)}
					</Route>
					<Route element={<StoreRecommendationProvider />} path={services.store_recommendation.path}>
						<Route index element={<Navigate to="home" replace />} />
						{Object.keys(storeRecommendationDashboardSideNavList).map((key) =>
							generateStoreRecommendationRoutesFromServiceTree(
								storeRecommendationDashboardSideNavList[key],
								services.store_recommendation.key,
							),
						)}
					</Route>
					<Route element={<PosRecoProvider />} path="pos_reco">
						{Object.keys(posDashboardSideNavList).map((key) =>
							generatePosRoutesFromServiceTree(posDashboardSideNavList[key], "pos_reco"),
						)}
					</Route>
					<Route element={<ReplenishmentProvider />} path={services.replenishment.path}>
						{Object.keys(replenishmentDrawerElements).map((key) =>
							generateReplenishmentRoutesFromServiceTree(replenishmentDrawerElements[key], services.replenishment.path),
						)}
					</Route>
					<Route element={<ShippingProviderRecoProvider />} path={services.shipping_partner_reco.path}>
						{Object.keys(shippingPartnerDrawerElements).map((key) =>
							generateShippingPartnerRecoRoutesFromServiceTree(
								shippingPartnerDrawerElements[key],
								services.shipping_partner_reco.path,
							),
						)}
					</Route>
					<Route element={<CustomQueriesProvider />} path={services.custom_queries.path}>
						<Route index element={<Navigate to={planningSaleQueryPath} />} />
						{Object.keys(customQuereiesDrawerElements).map((key) =>
							generateCustomQueriesRoutesFromServiceTree(
								customQuereiesDrawerElements[key],
								services.custom_queries.path,
							),
						)}
					</Route>
					<Route element={<AudienceDashboardProvider />} path={services.audience.path}>
						<Route index element={<Navigate to={audienceFacebookPagePath} />} />
						{Object.keys(audienceDrawerElements).map((key) =>
							generateAudienceRoutesFromServiceTree(audienceDrawerElements[key], services.audience.path),
						)}
					</Route>

					<Route path={services.ebo_payments.path} element={<EBOPayments />} />
					<Route path={services.users.path} element={<Users />} />
					<Route
						path={services.data_hub.path}
						element={<Dashboard drawerList={DataHubDrawerElements} searchParamName={DataHubTabParamName} navSpace={0} />}>
						<Route index element={<DataHub />} />
					</Route>
					<Route
						path={services.radhamani_web_data.path}
						element={<Dashboard drawerList={webDataDrawerElements} searchParamName={webDataParamName} navSpace={0} />}>
						<Route index element={<DashboardRWebData />} />
					</Route>

					<Route
						path={services.item_master.path}
						element={
							<Dashboard drawerList={itemMasterDrawerElements} searchParamName={itemMasterTabParamName} navSpace={0} />
						}>
						<Route index element={<ItemMasterDashboard />} />
					</Route>
					<Route path={services.designer_workspace.path} element={<DesignerWorkspace />} />
					<Route path={services.fabric_sourcing_workspace.path} element={<FabricSourcingWorkspace />} />
					<Route path={services.crm_workspace.path} element={<CrmWorkspace />} />
					<Route path={services.finance_workspace.path} element={<FinanceWorkspace />} />
					<Route path={services.hr_workspace.path} element={<HRWorkspace />} />
					<Route path={services.mbo_sale_workspace.path} element={<MboSaleWorkspace />} />
					<Route path={services.ops_report_workspace.path} element={<OpsReportWorkspace />} />
					<Route path={services.finance_payable_workspace.path} element={<FinancePayableWorkspace />} />
					<Route path={services.studio_workspace.path} element={<StudioWorkspace />} />
					<Route path={services.cad_workspace.path} element={<CADWorkspace />} />
					<Route
						path={services.online_reco.path}
						element={
							<Dashboard
								drawerList={myntra_reco_drawer}
								searchParamName={myntraRecoUrlParamName}
								navSpace={0}
								drawerWidth={150}
							/>
						}>
						<Route index element={<Myntra_reco />} />
					</Route>
					<Route path={services.business_plan.path} element={<BusinessPlanningProvider />}>
						<Route index element={<BusinessPlanning />} />
						<Route path="store" element={<Store />} />
						<Route path="category" element={<SubCategoryLevelBp />} />
					</Route>
					<Route path={services.business_plan_v2.path} element={<BusinessPlanV2Provider />}>
						<Route index element={<BusinessPlanV2 />} />
						<Route path="plan/:planId" element={<SelectedPlanPage />} />
						<Route path="store_bp" element={<StoreBp />} />
					</Route>

					<Route path={services.discount_master.path}>
						<Route index element={<MboPaymentWorkingExplore />} />
						<Route element={<MboPaymentProvider />}>
							{/* </Route> */}
							{Object.keys(mboPaymentDashboardServices)
								.reduce((acc, row) => {
									const service = mboPaymentDashboardServices[row];
									if (service?.types && typeof service?.types === "object") {
										Object.keys(service.types).forEach((key) => {
											acc.push(service.types[key]);
										});
									} else acc.push(service);
									return acc;
								}, [])
								.map((row) => {
									return (
										<Route
											path={row.key}
											key={row.key}
											element={
												<DashboardWithMiniCollapsableDrawer
													drawerList={mboPaymentDashboardServices}
													searchParamName={"tab"}
													navSpace={0}
													service={row}
													pathName={row.key}
													rootPath={services.discount_master.path}
												/>
											}>
											<Route index element={<MboPaymentWorking />} />
										</Route>
									);
								})}
						</Route>
					</Route>
					<Route path={services.mbo_sale_payment_working.path}>
						<Route index element={<MboSalePaymentWorkingExplore />} />
						{Object.keys(mboSalePaymentDashboardServices)
							.reduce((acc, row) => {
								const service = mboSalePaymentDashboardServices[row];
								if (service?.types && typeof service?.types === "object") {
									Object.keys(service.types).forEach((key) => {
										acc.push(service.types[key]);
									});
								} else acc.push(service);
								return acc;
							}, [])
							.map((row) => {
								return (
									<Route
										path={row.key}
										key={row.key}
										element={
											<DashboardWithMiniCollapsableDrawer
												drawerList={mboSalePaymentDashboardServices}
												searchParamName={"tab"}
												navSpace={0}
												service={row}
												pathName={row.key}
												rootPath={services.mbo_sale_payment_working.path}
											/>
										}>
										<Route index element={<MboSalePaymentWorking />} />
									</Route>
								);
							})}
					</Route>
					<Route path={services.lfs_sale_payment_working.path}>
						<Route index element={<LfsSalePaymentWorkingExplore />} />
						{Object.keys(lfsSalePaymentDashboardServices)
							.reduce((acc, row) => {
								const service = lfsSalePaymentDashboardServices[row];
								if (service?.types && typeof service?.types === "object") {
									Object.keys(service.types).forEach((key) => {
										acc.push(service.types[key]);
									});
								} else acc.push(service);
								return acc;
							}, [])
							.map((row) => {
								return (
									<Route
										path={row.key}
										key={row.key}
										element={
											<DashboardWithMiniCollapsableDrawer
												drawerList={lfsSalePaymentDashboardServices}
												searchParamName={"tab"}
												navSpace={0}
												service={row}
												pathName={row.key}
												rootPath={services.lfs_sale_payment_working.path}
											/>
										}>
										<Route index element={<LfsSalePaymentWorking />} />
									</Route>
								);
							})}
					</Route>
					<Route path={services.ebo_payments.path}>
						<Route index element={<EboPaymentWorkingExplore />} />
						<Route element={<EboPaymentProvider />}>
							{/* </Route> */}
							{Object.keys(eboPaymentDashboardServices)
								.reduce((acc, row) => {
									const service = eboPaymentDashboardServices[row];
									if (service?.types && typeof service?.types === "object") {
										Object.keys(service.types).forEach((key) => {
											acc.push(service.types[key]);
										});
									} else acc.push(service);
									return acc;
								}, [])
								.map((row) => {
									return (
										<Route
											path={row.key}
											key={row.key}
											element={
												<DashboardWithMiniCollapsableDrawer
													drawerList={eboPaymentDashboardServices}
													searchParamName={"tab"}
													navSpace={0}
													service={row}
													pathName={row.key}
													rootPath={services.ebo_payments.path}
												/>
											}>
											<Route index element={<EboPaymentWorking />} />
										</Route>
									);
								})}
						</Route>
					</Route>

					{/* sora — moved to its own subdomain (sign-in via hq). The route stays only so old
					    bookmarks and deep links land at the new home instead of a blank page. */}
					<Route path={`${services.sora.path}/*`} element={<SoraMoved />} />

					{/* return module */}
					<Route path={services.return_module.path} element={<ReturnModule />}>
						<Route index element={<ReturnModuleDashboard />} />
					</Route>
					{/* store budget tracker module */}
					<Route path={services.store_budget_tracker.path}>
						<Route index element={<StoreBudgetExplore />} />
						<Route element={<StoreBudgetProvider />}>
							{/* </Route> */}
							{Object.keys(storeBudgetDashboardServices)
								.reduce((acc, row) => {
									const service = storeBudgetDashboardServices[row];
									if (service?.types && typeof service?.types === "object") {
										Object.keys(service.types).forEach((key) => {
											acc.push(service.types[key]);
										});
									} else acc.push(service);
									return acc;
								}, [])
								.map((row) => {
									return (
										<Route
											path={row.key}
											key={row.key}
											element={
												<DashboardWithMiniCollapsableDrawer
													drawerList={storeBudgetDashboardServices}
													searchParamName={"tab"}
													navSpace={0}
													service={row}
													pathName={row.key}
													rootPath={services.store_budget_tracker.path}
												/>
											}>
											<Route index element={<StoreBudgetTracker />} />
										</Route>
									);
								})}
						</Route>
					</Route>
					{/* ebo store expenses module */}
					<Route path={services.ebo_store_expenses.path}>
						<Route index element={<EboStoreExpensesExplore />} />
						<Route element={<EboStoreExpensesProvider />}>
							{/* </Route> */}
							{Object.keys(eboStoreExpensesServices)
								.reduce((acc, row) => {
									const service = eboStoreExpensesServices[row];
									if (service?.types && typeof service?.types === "object") {
										Object.keys(service.types).forEach((key) => {
											acc.push(service.types[key]);
										});
									} else acc.push(service);
									return acc;
								}, [])
								.map((row) => {
									return (
										<Route
											path={row.key}
											key={row.key}
											element={
												<DashboardWithMiniCollapsableDrawer
													drawerList={eboStoreExpensesServices}
													searchParamName={"tab"}
													navSpace={0}
													service={row}
													pathName={row.key}
													rootPath={services.ebo_store_expenses.path}
												/>
											}>
											<Route index element={<EboStoreExpenses />} />
										</Route>
									);
								})}
						</Route>
					</Route>
					{/* refund tracker module */}
						<Route path={services.refund_tracker.path}>
						<Route index element={<RefundTrackerExplore />} />
						<Route element={<RefundTrackerProvider />}>
							{/* </Route> */}
							{Object.keys(refundTrackerServices)
								.reduce((acc, row) => {
									const service = refundTrackerServices[row];
									if (service?.types && typeof service?.types === "object") {
										Object.keys(service.types).forEach((key) => {
											acc.push(service.types[key]);
										});
									} else acc.push(service);
									return acc;
								}, [])
								.map((row) => {
									return (
										<Route
											path={row.key}
											key={row.key}
											element={
												<DashboardWithMiniCollapsableDrawer
													drawerList={refundTrackerServices}
													searchParamName={"tab"}
													navSpace={0}
													service={row}
													pathName={row.key}
													rootPath={services.refund_tracker.path}
												/>
											}>
											<Route index element={<RefundTrackerPage />} />
										</Route>
									);
								})}
						</Route>
					</Route>

					{/* AXIS — requires admin or service-level role.AXIS */}
					<Route path={services.wh_allocation.path} element={<AxisRouteGuard />} />
				</Route>

				{/* Routes with no auth */}
				<Route path="open" element={<DefaultOpenLayout />}>
					<Route index element={<SupplierForm />} />
					<Route path="supplier" element={<SupplierForm />} />
				</Route>
				{/* Public legal pages (Google OAuth brand verification). Rendered without
				    DefaultOpenLayout so the app Navbar never appears on a public page. */}
				<Route path="privacy-policy" element={<PrivacyPolicy />} />
				<Route path="terms-of-service" element={<TermsOfService />} />

				<Route path="change_password" element={<ChangePassword />} />
				<Route path="password-reset/:token" element={<DefaultOpenLayout />}>
					<Route index element={<ForgotPasswordReset />} />
				</Route>
				<Route path="external">
					<Route
						path="supplier"
						element={
							<AuthProvider>
								<Outlet />
							</AuthProvider>
						}>
						<Route index element={<Navigate to="company_info" replace />} />
						{generateSupplierRoutesFromDrawer(supplierDrawerElements, {
							rootPath: supplierExternalRootPath,
							navBasePath: supplierExternalNavBasePath,
							element: <SupplierUser />,
							// No DefaultLayout here — content must clear the fixed AppBar
							navSpace: 8,
						})}
					</Route>
					<Route
						path="store"
						element={
							<AuthProvider>
								<DefaultLayout />
								{/* <DataHubStoreView /> */}
							</AuthProvider>
						}>
						<Route index element={<DataHubStoreView />} />
					</Route>
					<Route
						path="warehouse"
						element={
							<AuthProvider>
								<DefaultLayout />
								{/* <DataHubStoreView /> */}
							</AuthProvider>
						}>
						<Route index element={<DataHubWarehouseView />} />
					</Route>
					<Route
						path="ADYOGI"
						element={
							<AuthProvider>
								<DefaultLayout />
							</AuthProvider>
						}>
						<Route index element={<Navigate to="reports" replace />} />
						{/* {generateAdyogiReportsRoutesFromServiceTree(adyogiReportsDashboardSideNavList, "reports")} */}
						<Route element={<ReportsProvider />} path="reports">
							<Route index element={<Navigate to={adyogiReportsDashboardSideNavList.shopify_live_sale.key} replace />} />

							{Object.keys(adyogiReportsDashboardSideNavList).map((key) =>
								generateAdyogiReportsRoutesFromServiceTree(adyogiReportsDashboardSideNavList[key], "reports"),
							)}
						</Route>
					</Route>
					<Route
						path="GUJRAT_SALE"
						element={
							<AuthProvider>
								<DefaultLayout />
							</AuthProvider>
						}>
						<Route index element={<Navigate to="custom_sale_report" replace />} />

						<Route element={<ReportsProvider />} path="custom_sale_report">
							<Route
								index
								element={<Navigate to={gujratSaleExternalDashboardSideNavList.ebo_sale_gujrat.key} replace />}
							/>

							{Object.keys(gujratSaleExternalDashboardSideNavList).map((key) =>
								generateGujratSaleRoutesFromServiceTree(
									gujratSaleExternalDashboardSideNavList[key],
									"custom_sale_report",
								),
							)}
						</Route>
					</Route>
				</Route>
				<Route path="/discount-action" element={<DefaultOpenLayout />}>
					<Route index element={<DiscountActionPage />} />
				</Route>
			</Routes>
		</Box>
	);
}

export default App;
